module.exports = __webpack_public_path__ + "img/number-one.dece3c2b.png";